var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"CtkSideBar",staticClass:"ctk-side-bar tw-relative tw-flex tw-flex-1 tw-bg-bg-primary tw-z-50",class:{
    'hide-side-bar': !_vm.open,
    'absolute': _vm.absolute,
    'with-shadow': !_vm.withoutShadow,
    'right': _vm.right
  },attrs:{"id":"CtkSideBar"}},[_c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('div',{staticClass:"content tw-flex tw-flex-1 tw-w-full"},[_vm._t("default")],2)]),(!_vm.withoutCloseBtn)?_c('ctk-side-bar-toggle',{attrs:{"open":_vm.open,"right":_vm.right},on:{"toggle":_vm.toggleMenu}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }